import VerifyDocumentPage from "./VerifyDocument";

export default VerifyDocumentPage;
